import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { InterviewProblem } from "../../models/problems";
import { COLOR_PRIMARY, COLOR_TEXT_MUTED } from "../../styles/colors";
import { ProblemLibrary } from "./ProblemLibrary";

interface ProblemLibraryModalProps {
  open: boolean;
  onClose: () => void;
  onStarted: (problem: InterviewProblem) => void;
}

const ProblemLibraryModal: React.FC<ProblemLibraryModalProps> = ({ open, onClose, onStarted }) => (
  <Dialog open={open} onClose={onClose} aria-labelledby="problem-library-dialog-title" maxWidth="sm" fullWidth scroll="paper">
    <DialogTitle id="problem-library-dialog-title" sx={{ fontWeight: 700, color: COLOR_PRIMARY, pr: 6 }}>
      Problem Library
      <Typography component="span" variant="body2" sx={{ display: "block", color: COLOR_TEXT_MUTED }}>
        Practice classic system design interview problems with realistic traffic.
      </Typography>
      <IconButton aria-label="close" onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>
      <ProblemLibrary
        onStarted={(problem) => {
          onStarted(problem);
          onClose();
        }}
      />
    </DialogContent>
  </Dialog>
);

export default ProblemLibraryModal;
